import type { ModuleDefinition } from '@em-cms/core';

export const moduleConfig = {
  id: 'projects',
  name: 'پروژه‌ها',
  description: 'مدیریت نمونه‌کارها و پروژه‌ها',
  version: '0.1.0',
  is_core: false,
  requires: [],
  tables: ['cms_projects'],
};

export const projectsModule: ModuleDefinition = {
  id: 'projects',
  name: 'پروژه‌ها',
  description: 'مدیریت نمونه‌کارها و پروژه‌ها',
  version: '0.1.0',
  icon: 'Briefcase',
  category: 'content',
  dependencies: [],
  tables: ['cms_projects'],
  adminRoutes: [
    {
      path: '/projects',
      component: () => import('./admin/ProjectsListPage').then(m => ({ default: m.ProjectsListPage })),
      permission: 'projects.read',
      label: 'پروژه‌ها',
      icon: 'Briefcase',
    },
    {
      path: '/projects/new',
      component: () => import('./admin/ProjectEditPage').then(m => ({ default: m.ProjectEditPage })),
      permission: 'projects.create',
      label: 'پروژه جدید',
    },
    {
      path: '/projects/edit/:id',
      component: () => import('./admin/ProjectEditPage').then(m => ({ default: m.ProjectEditPage })),
      permission: 'projects.update',
      label: 'ویرایش پروژه',
    },
  ],
};
